
import Vue from "vue";
import AppExtraFieldsInfo from "@/components/ExtraFieldsInfo.vue";
import { BrowseState } from "@/utils/browse/browse-state";
import { IBrowseDataSourceExtraFields } from "@/utils/browse/browse-data-source";
import { IExtraFields } from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			loading: false,
			extraFields: null as IExtraFields | null,
			loadedForId: 0
		};
	},
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseState,
			required: true
		}
	},
	computed: {
		settings():IBrowseDataSourceExtraFields<any> | undefined {
			return this.state.dataSource.extraFieldSettings;
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				this.load();
			}
		}
	},
	methods: {
		async load(){
			let id = this.item.ID;
			if (!id || !this.settings) return;
			if (this.item.ExtraFields && this.item.ExtraFields.ID != 0) {
				this.extraFields = this.item.ExtraFields;
				this.loadedForId = id;
				return;
			}
			if (this.loadedForId == id) return;
			this.loadedForId = id;
			this.loading = true;
			try {
				let result = await this.settings.getExtraFields(this.item);
				if (this.item.ID != id) return;
				this.extraFields = result;
			} catch (err) {
				this.extraFields = null;
			} finally {
				this.loading = false;
			}
		}
	},
	components: {
		AppExtraFieldsInfo
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
